import Button from '../../components/Button/Button'
import styles from './PriceList.module.scss'
const PriceList: React.FC = () => {
  return (
    <div className={styles.section}>
      <h2>料金表</h2>
      <p>料金に関しては、フォームからお問い合わせください。</p>
      {/* <Button /> */}
    </div>
  )
}
export default PriceList
